import { t } from '@superset-ui/core';
import { ControlPanelConfig } from '@superset-ui/chart-controls';

const config: ControlPanelConfig = {
  controlPanelSections: [
    {
      label: t('Запрос'),
      expanded: true,
      controlSetRows: [['groupby'], ['metrics'], ['adhoc_filters'], ['row_limit']],
    },
    {
      label: t('Календарь'),
      expanded: true,
      controlSetRows: [
        [
          {
            name: 'months_per_page',
            config: {
              type: 'SelectControl',
              label: t('Месяцев на странице'),
              default: 2,
              renderTrigger: true,
              freeForm: false,
              choices: [
                [1, '1'],
                [2, '2'],
                [3, '3'],
                [6, '6'],
                [12, '12'],
              ],
              description: t('Сколько месяцев показывать на одной странице'),
            },
          },
          {
            name: 'cell_min_height',
            config: {
              type: 'SelectControl',
              label: t('Минимальная высота ячейки'),
              renderTrigger: true,
              freeForm: false,
              default: 140,
              choices: [
                [88, '88'],
                [110, '110'],
                [140, '140'],
                [180, '180'],
                [240, '240'],
                [320, '320'],
                [420, '420'],
              ],
              description: t('Минимальная высота ячейки дня'),
            },
          },
        ],
        [
          {
            name: 'show_outside_days',
            config: {
              type: 'CheckboxControl',
              label: t('Показывать дни соседних месяцев'),
              default: true,
              renderTrigger: true,
              description: t('Показывать дни до и после текущего месяца'),
            },
          },
          {
            name: 'compact_mode',
            config: {
              type: 'CheckboxControl',
              label: t('Компактный режим'),
              default: false,
              renderTrigger: true,
              description: t('Меньше внутренние отступы в ячейках'),
            },
          },
        ],
        [
          {
            name: 'display_mode',
            config: {
              type: 'SelectControl',
              label: t('Режим содержимого ячейки'),
              default: 'label_value',
              renderTrigger: true,
              freeForm: false,
              choices: [
                ['label_only', t('Только лейбл')],
                ['label_value', t('Лейбл + метрика')],
                ['value_only', t('Только метрика')],
              ],
              description: t('Что показывать внутри ячейки календаря'),
            },
          },
          {
            name: 'overflow_mode',
            config: {
              type: 'SelectControl',
              label: t('Режим переполнения'),
              default: 'scroll',
              renderTrigger: true,
              freeForm: false,
              choices: [
                ['scroll', t('Показывать все со скроллом')],
                ['expand', t('Растягивать строку календаря')],
              ],
              description: t('Как показывать содержимое, если оно не помещается'),
            },
          },
        ],
        [
          {
            name: 'cell_body_max_height',
            config: {
              type: 'SelectControl',
              label: t('Максимальная высота области прокрутки'),
              renderTrigger: true,
              freeForm: false,
              default: 180,
              choices: [
                [80, '80'],
                [120, '120'],
                [160, '160'],
                [180, '180'],
                [220, '220'],
                [280, '280'],
                [360, '360'],
              ],
              description: t('Используется только в режиме "Показывать все со скроллом"'),
            },
          },
          {
            name: 'font_family',
            config: {
              type: 'SelectControl',
              label: t('Семейство шрифта'),
              renderTrigger: true,
              freeForm: false,
              default:
                'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif',
              choices: [
                [
                  'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif',
                  t('Inter / системный'),
                ],
                ['"Segoe UI", Arial, sans-serif', t('Segoe UI')],
                ['Arial, sans-serif', t('Arial')],
                ['Roboto, Arial, sans-serif', t('Roboto')],
                ['Helvetica, Arial, sans-serif', t('Helvetica')],
                ['Georgia, "Times New Roman", serif', t('Georgia')],
                ['monospace', t('Моноширинный')],
              ],
              description: t('Шрифт календаря'),
            },
          },
        ],
        [
          {
            name: 'month_title_font_size',
            config: {
              type: 'SelectControl',
              label: t('Размер шрифта заголовка месяца'),
              renderTrigger: true,
              freeForm: false,
              default: 18,
              choices: [
                [14, '14'],
                [16, '16'],
                [18, '18'],
                [20, '20'],
                [22, '22'],
                [24, '24'],
              ],
              description: t('Размер заголовка месяца'),
            },
          },
          {
            name: 'header_font_size',
            config: {
              type: 'SelectControl',
              label: t('Размер шрифта дней недели'),
              renderTrigger: true,
              freeForm: false,
              default: 13,
              choices: [
                [11, '11'],
                [12, '12'],
                [13, '13'],
                [14, '14'],
                [15, '15'],
                [16, '16'],
              ],
              description: t('Размер шрифта заголовков дней недели'),
            },
          },
        ],
        [
          {
            name: 'day_number_font_size',
            config: {
              type: 'SelectControl',
              label: t('Размер номера дня'),
              renderTrigger: true,
              freeForm: false,
              default: 12,
              choices: [
                [10, '10'],
                [11, '11'],
                [12, '12'],
                [13, '13'],
                [14, '14'],
                [15, '15'],
                [16, '16'],
              ],
              description: t('Размер цифры дня в ячейке'),
            },
          },
          {
            name: 'body_font_size',
            config: {
              type: 'SelectControl',
              label: t('Размер текста в ячейке'),
              renderTrigger: true,
              freeForm: false,
              default: 12,
              choices: [
                [10, '10'],
                [11, '11'],
                [12, '12'],
                [13, '13'],
                [14, '14'],
                [15, '15'],
                [16, '16'],
              ],
              description: t('Размер текста внутри ячейки'),
            },
          },
        ],
        [
          {
            name: 'body_line_height',
            config: {
              type: 'SelectControl',
              label: t('Межстрочный интервал текста'),
              renderTrigger: true,
              freeForm: false,
              default: 1.3,
              choices: [
                [1.1, '1.1'],
                [1.2, '1.2'],
                [1.3, '1.3'],
                [1.4, '1.4'],
                [1.5, '1.5'],
                [1.6, '1.6'],
              ],
              description: t('Межстрочный интервал текста в ячейке'),
            },
          },
          {
            name: 'day_number_align',
            config: {
              type: 'SelectControl',
              label: t('Выравнивание номера дня'),
              renderTrigger: true,
              freeForm: false,
              default: 'right',
              choices: [
                ['left', t('Слева')],
                ['center', t('По центру')],
                ['right', t('Справа')],
              ],
              description: t('Горизонтальное выравнивание номера дня'),
            },
          },
        ],
        [
          {
            name: 'body_text_align',
            config: {
              type: 'SelectControl',
              label: t('Выравнивание текста'),
              renderTrigger: true,
              freeForm: false,
              default: 'left',
              choices: [
                ['left', t('Слева')],
                ['center', t('По центру')],
                ['right', t('Справа')],
              ],
              description: t('Горизонтальное выравнивание текста в ячейке'),
            },
          },
          {
            name: 'body_vertical_align',
            config: {
              type: 'SelectControl',
              label: t('Вертикальное выравнивание текста'),
              renderTrigger: true,
              freeForm: false,
              default: 'top',
              choices: [
                ['top', t('Сверху')],
                ['middle', t('По центру')],
                ['bottom', t('Снизу')],
              ],
              description: t('Вертикальное выравнивание текста в ячейке'),
            },
          },
        ],
      ],
    },
  ],
  controlOverrides: {
    groupby: {
      label: t('Измерения'),
      description: t(
        'Первое измерение должно быть датой по дням. Второе измерение — это лейбл внутри ячейки.',
      ),
    },
    metrics: {
      label: t('Метрика'),
      description: t('Используется только первая метрика. Можно оставить пустым для текстового режима.'),
    },
    row_limit: {
      label: t('Лимит строк'),
    },
  },
};

export default config;
